import http from '../services/http';

export default class Transaction {
  static fetchTransactions(params) {
    return http.get('/histories/admin-search', {
      params
    });
  }
}
